import { RequirementApprovalResponse, RequirementDecisionRequest as DecisionRequestDto, RequirementHistoryResponse, RequirementRequiredDecisionRequest as RequiredDecisionRequestDto } from "lib-klab-sdks";
import { RequirementApproval, RequirementDecisionRequest, RequirementHistory, RequirementRequiredDecisionRequest } from "../../../domain/models/requirement/requirement-workflow.model";

export function mapRequirementApproval(source: RequirementApprovalResponse): RequirementApproval {
  return {
    id: source.requirementApprovalId,
    requirementId: source.requirementId,
    approvalStage: source.approvalStage,
    stageOrder: source.stageOrder,
    roundNumber: source.roundNumber,
    approverUserId: source.approverUserId,
    decisionStatusId: source.decisionStatusId,
    comment: source.comment,
    decidedAt: source.decidedAt,
    createdAt: source.createdAt,
  };
}

export function mapRequirementHistory(source: RequirementHistoryResponse): RequirementHistory {
  return {
    id: source.requirementStatusHistoryId,
    requirementId: source.requirementId,
    action: source.action,
    previousStatusId: source.previousStatusId,
    newStatusId: source.newStatusId,
    actorUserId: source.actorUserId,
    comment: source.comment,
    changes: source.changes,
    createdAt: source.createdAt,
  };
}

export function mapRequirementDecisionRequest(request: RequirementDecisionRequest): DecisionRequestDto {
  return { comment: request.comment };
}

export function mapRequirementRequiredDecisionRequest(request: RequirementRequiredDecisionRequest): RequiredDecisionRequestDto {
  return { comment: request.comment };
}
